/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ShipmentImperfectionReason } from "./ShipmentImperfectionReason";
import {
  ShipmentImperfectionReasonFromJSON,
  ShipmentImperfectionReasonFromJSONTyped,
  ShipmentImperfectionReasonToJSON,
  ShipmentImperfectionReasonToJSONTyped,
} from "./ShipmentImperfectionReason";

/**
 *
 * @export
 * @interface ShipmentImperfection
 */
export interface ShipmentImperfection {
  /**
   *
   * @type {string}
   * @memberof ShipmentImperfection
   */
  shipmentImperfectionId?: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentImperfection
   */
  shipmentId?: string;
  /**
   *
   * @type {ShipmentImperfectionReason}
   * @memberof ShipmentImperfection
   */
  reason?: ShipmentImperfectionReason;
  /**
   *
   * @type {string}
   * @memberof ShipmentImperfection
   */
  detail?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ShipmentImperfection
   */
  detectedAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the ShipmentImperfection interface.
 */
export function instanceOfShipmentImperfection(
  value: object,
): value is ShipmentImperfection {
  return true;
}

export function ShipmentImperfectionFromJSON(json: any): ShipmentImperfection {
  return ShipmentImperfectionFromJSONTyped(json, false);
}

export function ShipmentImperfectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentImperfection {
  if (json == null) {
    return json;
  }
  return {
    shipmentImperfectionId:
      json["shipmentImperfectionId"] == null
        ? undefined
        : json["shipmentImperfectionId"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    reason:
      json["reason"] == null
        ? undefined
        : ShipmentImperfectionReasonFromJSON(json["reason"]),
    detail: json["detail"] == null ? undefined : json["detail"],
    detectedAt: json["detectedAt"] == null ? undefined : json["detectedAt"],
  };
}

export function ShipmentImperfectionToJSON(json: any): ShipmentImperfection {
  return ShipmentImperfectionToJSONTyped(json, false);
}

export function ShipmentImperfectionToJSONTyped(
  value?: ShipmentImperfection | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentImperfectionId: value["shipmentImperfectionId"],
    shipmentId: value["shipmentId"],
    reason: ShipmentImperfectionReasonToJSON(value["reason"]),
    detail: value["detail"],
    detectedAt: value["detectedAt"],
  };
}
